const jingrqEndpointConfig = {
  httpEndpoint: 'https://upeklfr4gj.execute-api.us-west-2.amazonaws.com/test/',
  cognitoIdentityPoolId: 'us-west-2:ccddcb31-063d-43e9-a241-c046762695fa',
  region: 'us-west-2',
};

const alphaEndpointConfig = {
  httpEndpoint: 'https://e337xxfq8i.execute-api.us-west-2.amazonaws.com/alpha/',
  cognitoIdentityPoolId: 'us-west-2:7e4f50ee-5b3f-4f35-a31e-911f2b7218b7',
  region: 'us-west-2',
};

export function getAsinMetricsEndpointConfig() {
  const url = window.location.hostname;
  switch (url) {
    case 'localhost.a2z.com':
      // Change to your SAM API Gateway endpoint here for testing locally
      // TODO: find a way so that developer don't have to change this each time to run locally.
      return jingrqEndpointConfig;
    case 'tools-jingrq.profit-intelligence.selling-partners.a2z.com':
      return jingrqEndpointConfig;
    case 'tools-alpha.profit-intelligence.selling-partners.a2z.com':
      return alphaEndpointConfig;
    default:
      throw new Error(`No endpoint configured for ${url}`);
  }
}



// WEBPACK FOOTER //
// ./src/components/reports/asin_metrics/asin-metrics-endpoint-configs.js